var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isNullOrUndefined } from "../utils/functions";
var ActionResult = /** @class */ (function () {
    function ActionResult(isSuccess, result, errorModel) {
        this._isSuccess = isSuccess;
        this._result = isNullOrUndefined(result) ? null : result;
        this._errorModel = isNullOrUndefined(errorModel) ? null : errorModel;
    }
    Object.defineProperty(ActionResult.prototype, "isSuccess", {
        get: function () {
            return this._isSuccess;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionResult.prototype, "result", {
        get: function () {
            return this._result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionResult.prototype, "errorModel", {
        get: function () {
            return this._errorModel;
        },
        enumerable: true,
        configurable: true
    });
    return ActionResult;
}());
export { ActionResult };
var SuccessActionResult = /** @class */ (function (_super) {
    __extends(SuccessActionResult, _super);
    function SuccessActionResult(result) {
        return _super.call(this, true, result) || this;
    }
    return SuccessActionResult;
}(ActionResult));
export { SuccessActionResult };
var FailActionResult = /** @class */ (function (_super) {
    __extends(FailActionResult, _super);
    function FailActionResult(errorModel) {
        return _super.call(this, false, undefined, errorModel) || this;
    }
    return FailActionResult;
}(ActionResult));
export { FailActionResult };
